import { AuthContent, AuthContext } from '@admin/components/auth'
import TextField from '@admin/components/form/textfield'
import Avatar from '@admin/components/avatar'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Mobile extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    account: PropTypes.object,
    token: PropTypes.string,
    onNext: PropTypes.func
  }

  state = {
    code: null,
    method: 'sms',
    sent: false,
    status: 'pending'
  }

  _handleMethod = this._handleMethod.bind(this)
  _handleNext = this._handleNext.bind(this)
  _handleSend = this._handleSend.bind(this)
  _handleVerify = this._handleVerify.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    return (
      <AuthContext.Consumer>
        {(authContext) => {
          this._authContext = authContext
          return this._renderContent()
        }}
      </AuthContext.Consumer>
    )
  }

  _renderContent() {
    const { account } = this.props
    const { sent } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-content">
            { account && <Avatar user={ account } width="150" presence={ false } /> }
            { account && <h2>{ account.full_name }</h2> }
            <p><T text="Before we can reset your password, we need to verify you with a push message" /></p>
          </div>
          <div className="ui form">
            { sent &&
              <div className="field">
                <TextField { ...this._getTextField() } />
              </div>
            }
            <div className="field button-field">
              { sent ?
                <Button { ...this._getVerify() } /> :
                <Button { ...this._getSend() } />
              }
            </div>
          </div>
          <div className="maha-auth-footer">
            { sent ?
              <><Button { ...this._getResend() } /> | <Button { ...this._getMethod() } /></> :
              <><Button { ...this._getSkip() } /> | <Button { ...this._getMethod() } /></>
            }
          </div>
        </div>
      </AuthContent>
    )
  }

  _getMethod() {
    const { method } = this.state
    return {
      label: method === 'sms' ? 't(Call me instead)' : 't(Text me instead)',
      className: 'link',
      handler: this._handleMethod

    }
  }

  _getPhoneField() {
    return {
      onChange: this._handleUpdate.bind(this, 'mobile_phone')
    }
  }

  _getResend() {
    const { method } = this.state
    return {
      label: method === 'sms' ? 't(Resend code)' : 't(Call me again)',
      className: 'link',
      handler: this._handleSend
    }
  }

  _getSkip() {
    return {
      label: 't(Skip for now)',
      className: 'link',
      handler: this._handleNext
    }
  }

  _getSend() {
    const { method, status } = this.state
    return {
      label: method === 'sms' ? 't(Send SMS)' : 't(Call Me)',
      color: 'blue',
      loading: status === 'submitting',
      handler: this._handleSend
    }
  }

  _getTextField() {
    return {
      placeholder: 't(Enter Verification Code)',
      onChange: this._handleUpdate.bind(this, 'code')
    }
  }

  _getVerify() {
    const { status } = this.state
    return {
      label: 't(Verify Code)',
      color: 'blue',
      loading: status === 'submitting',
      handler: this._handleVerify
    }
  }

  _handleMethod() {
    const { method } = this.state
    this.setState({
      method: method === 'sms' ? 'voice' : 'sms',
      sent: false
    })
  }

  _handleNext() {
    this.props.onNext('password')
  }

  _handleSend() {
    const { method } = this.state
    const { token } = this.props
    this.setState({ status: 'submitting' })
    this.context.network.request({
      endpoint: '/api/admin/reset/twofactor/authorize',
      method: 'POST',
      body: { token, method },
      onSuccess: () => {
        this.setState({
          method,
          status: 'pending',
          sent: true
        })
      },
      onFailure: () => {
        this._authContext.shake()
        this.setState({
          status: 'pending'
        })
      }
    })
  }

  _handleVerify() {
    const { token } = this.props
    const { code } = this.state
    this.setState({ sent: true, status: 'submitting' })
    this.context.network.request({
      endpoint: '/api/admin/reset/twofactor/verify',
      method: 'POST',
      body: { token, code },
      onSuccess: this._handleNext,
      onFailure: () => {
        this._authContext.shake()
        this.setState({
          status: 'pending'
        })
      }
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Mobile
